"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiIconButtonOverrides = void 0;
var createMuiIconButtonOverrides = function (_a) {
    var spacing = _a.spacing, shape = _a.shape, palette = _a.palette;
    return ({
        root: {
            padding: "calc(" + spacing(4) + "px - 0.75rem)",
            borderRadius: shape.borderRadius,
            color: palette.text.primary,
            "&:hover": {
                backgroundColor: palette.action.hover,
            },
            "&.Mui-focusVisible": {
                backgroundColor: palette.action.hover,
                boxShadow: "inset 0px 0px 0px 1px " + palette.text.primary,
            },
            "&:active": {
                backgroundColor: palette.action.active,
            },
        },
        sizeSmall: {
            padding: spacing(1),
        },
    });
};
exports.createMuiIconButtonOverrides = createMuiIconButtonOverrides;
//# sourceMappingURL=MuiIconButton.js.map